import React, { useState, useEffect } from "react";
import { Button, Space, Typography, Divider, Modal, Table } from "antd";
import { apiCall } from "../utils/Api";
import { CloseOutlined } from '@ant-design/icons';
import { colorDate, getListPrice, parseSubjectsList } from "../utils/Utils";
import moment from "moment-timezone";
import TitleRank from "./TitleRank";
import { Link } from "react-router-dom";
export default function TitleRelated(props) {

    const [visible, setVisible] = useState(false);
    const { eisbn, related_count = {
        previous_edition: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        next_edition: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        comparable_titles: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        included_items: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        included_in: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        other_languages: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        },
        other_titles: {
            fullname: "",
            shortname: "",
            shortkey: "",
            ids: [],
            count: 0,
        }


    }, drawComponent = () => { }, isbns = false, header = "", title = "" } = props;

    const [results, setResults] = useState(false)
    const [label, setLabel] = useState("");
    const getRelatedEditions = (_key) => {
        
        let _lbl = related_count[_key].short_name + " " + "(" + related_count[_key].count + ")";
        setLabel(_lbl);
        apiCall("title/getRelatedEditionsDetails", { eisbn: eisbn, detail_category: _key, limit: 20, offset: 0 }, (_status, _result) => {
            if (_status) {
                setResults(_result)
                setVisible(true);
            }
        })
    }

    //useEffect(getRelatedEditions, [isbn]);

    const drawButtons = () => {

        return Object.keys(related_count).map((key, index) => {

            if (related_count[key].count > 0) {
                return <Button key={index} size="small" className="mini-btn" onClick={() => getRelatedEditions(key)} ><small>{related_count[key].short_name} ({related_count[key].count})</small></Button>
            }
        })
    }


    const drawTitles = () => {
        return (
            <>
                <div className="closebar">
                    <Button style={{ "float": "right" }} onClick={() => drawComponent(null)} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px" }} /></small>} />
                    <div style={{ "padding": "8px 20px", "paddingBottom": "0px" }}>
                        <Typography.Title style={{ "lineHeight": "17px" }} level={5}>
                            <div>{header}</div>
                        </Typography.Title>
                    </div>
                </div>
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <div>
                    {isbns.map((item, index) => {
                        return (
                            <>{JSON.stringify(item, null, 2)}</>
                        )
                    })}
                </div>
            </>
        )
    }


     const columns = [

            {
                title: <small>Title</small>, dataIndex: 'title', key: 'title', render: (e, f) => {
                    return <div className='overhide' style={{ "minWidth": "190px" }} ><Link onClick={() => setVisible(false)} to={"/item/" + f.eisbn} style={{ "cursor": "pointer" }}>{e}<div style={{ "opacity": "0.7", "fontSize": "12px" }}>{(f.subtitle) ? f.subtitle : ""}</div></Link></div>
                }
            },
            {
                title: <small>Author</small>, style: { "overflow": "hidden" }, dataIndex: 'authors', key: 'authors', render: (e) => {
                    return <div className='overhide'>{e.map(item => item.name).join(", ")}</div>
                }
            }
    
        ]

    if (isbns) {

        return (
            <>
                {drawTitles()}
            </>
        )

    } else {

        return (

            <>
                <Modal footer={null} onCancel={() => setVisible(false)} open={visible}>
                    <strong>{label}</strong><div className="shim" /><div className="shim" />
                    <Table scroll={{y : 320}} pagination={false} columns={columns} dataSource={results.rows} />
                </Modal>
                <Space wrap size={3}>
                    {drawButtons()}
                </Space>
            </>
        );


    }





}